export const UNAUTHORIZED = 'Unauthorized';
export const MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED';
export const MFA_REQUIRED = 'MFA_REQUIRED';
